import { useDrawer, useDrawerInstance } from '@cast/design-system';

import { NotFoundClustersDrawer } from './NotFoundClustersDrawer';

export const useNotFoundClustersDrawer = () => {
  const { open } = useDrawer();
  const { id } = useDrawerInstance();

  return {
    openNotFoundClustersDrawer: () => {
      open({
        component: NotFoundClustersDrawer,
        props: {},
        options: { parentId: id },
      });
    },
  };
};
